module.exports = __webpack_public_path__ + "static/media/dove1.a8f62eda.webp";